module.exports = __webpack_public_path__ + "static/media/logo.9be8032c.svg";